import React from 'react';

import styles from '../../../assets/stats.module.css'

const TableComponent = ({topics,friendtopics,userName,friendName}) => {

    let total=0;
    let data=[]
    if(topics!==undefined && topics!==null && friendtopics===undefined)
    {
        for(let key in topics)
        {
            total+=topics[key]
        }
        for(let key in topics)
        {
            let number=100*(topics[key]/total)
            data.push({topic:key,problemsCount:topics[key],percentage:number.toFixed(2)})
        }
    }
    else if(friendtopics!==undefined)
    {
      let cur_topics={}
      for(let key in friendtopics)
        {
            if(key in topics )
            {
              data.push({topic:key,problemsCount:topics[key],percentage:friendtopics[key]})
            }
            else{
              data.push({topic:key,problemsCount:0,percentage:friendtopics[key]})
            }
            cur_topics[key]=1
        }
        for(let key in topics)
        {
          if(key in cur_topics)continue;
            if(key in friendtopics )
            {
              data.push({topic:key,problemsCount:topics[key],percentage:friendtopics[key]})
            }
            else{
              data.push({topic:key,problemsCount:topics[key],percentage:0})
            }
            cur_topics[key]=1
        }
      
    }

  return (
    <div className={styles['table-container']}>
     <table>
          <thead>
            <tr className="d-none d-md-table-row">
          <th>Topic Name</th>
          <th>{friendName===undefined?"Problems Count":userName[0].toUpperCase()+userName.substring(1)}</th>
          <th>{friendName===undefined?"Percentage":friendName[0].toUpperCase()+friendName.substring(1)}</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr className={styles.tableRow}  key={index}>
            <td className={styles.cell}>{item.topic}</td>
            <td className={styles.cell}>{item.problemsCount}</td>
            <td className={styles.cell}>{item.percentage}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  
  );
};

export default TableComponent;
